import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export abstract class OfficerDetailsBaseService {
  abstract fetchCurrentOfficer(): void;
}
